import { SuperappProvider } from './types'

export const superAppSubdomain: Record<string, SuperappProvider> = {
  kaspi: SuperappProvider.KASPI,
}
